function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSystemCalendar20Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "#BEC2CB"
    },
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AC97E3B8-F830-4866-9308-24144435E87A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/System/Calendar/20px",
    stroke: "none",
    strokeWidth: 1,
    fill: "#BEC2CB",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEC2CB"
    },
    d: "M19,6 L1,6 L1,3 L4,3 C4,3.55 4.45,4 5,4 L6,4 C6.55,4 7,3.55 7,3 L13,3 C13,3.55 13.45,4 14,4 L15,4 C15.55,4 16,3.55 16,3 L19,3 L19,6 Z M16.2,10.33 L19,10.33 L19,7 L16.2,7 L16.2,10.33 Z M16.2,14.67 L19,14.67 L19,11.33 L16.2,11.33 L16.2,14.67 Z M16.2,19 L19,19 L19,15.67 L16.2,15.67 L16.2,19 Z M12.4,10.33 L15.2,10.33 L15.2,7 L12.4,7 L12.4,10.33 Z M12.4,14.67 L15.2,14.67 L15.2,11.33 L12.4,11.33 L12.4,14.67 Z M12.4,19 L15.2,19 L15.2,15.67 L12.4,15.67 L12.4,19 Z M8.6,10.33 L11.4,10.33 L11.4,7 L8.6,7 L8.6,10.33 Z M8.6,14.67 L11.4,14.67 L11.4,11.33 L8.6,11.33 L8.6,14.67 Z M8.6,19 L11.4,19 L11.4,15.67 L8.6,15.67 L8.6,19 Z M4.8,10.33 L7.6,10.33 L7.6,7 L4.8,7 L4.8,10.33 Z M4.8,14.67 L7.6,14.67 L7.6,11.33 L4.8,11.33 L4.8,14.67 Z M4.8,19 L7.6,19 L7.6,15.67 L4.8,15.67 L4.8,19 Z M1,10.33 L3.8,10.33 L3.8,7 L1,7 L1,10.33 Z M1,14.67 L3.8,14.67 L3.8,11.33 L1,11.33 L1,14.67 Z M1,19 L3.8,19 L3.8,15.67 L1,15.67 L1,19 Z M5,3 L6,3 L6,1 L5,1 L5,3 Z M14,3 L15,3 L15,1 L14,1 L14,3 Z M19,2 L16,2 L16,1 C16,0.45 15.55,0 15,0 L14,0 C13.45,0 13,0.45 13,1 L13,2 L7,2 L7,1 C7,0.45 6.55,0 6,0 L5,0 C4.45,0 4,0.45 4,1 L4,2 L1,2 C0.45,2 0,2.45 0,3 L0,19 C0,19.55 0.45,20 1,20 L19,20 C19.55,20 20,19.55 20,19 L20,3 C20,2.45 19.55,2 19,2 L19,2 Z",
    id: "Fill-1",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSystemCalendar20Px);
export default __webpack_public_path__ + "static/media/Icon_System_Calendar_20px.ba50c4749e969129dc3ad36fa1ac72e5.svg";
export { ForwardRef as ReactComponent };